import { apiRoutes } from "../Constant/ApiRoutes";
import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../apiRequest";

const getKbParams = () => {
  const kbId = window.__kbId;
  return kbId ? { knowledgeBaseId: kbId } : undefined;
};

export const getDomainDetails = () => {
  return getRequest(apiRoutes.kbGetCustomDomainDetails, getKbParams());
};

export const initiateCustomDomain = (domainName) => {
  return postRequest(apiRoutes.KbCustomDomainInitiate, {}, {
    customDomain: domainName,
    ...getKbParams(),
  });
};

export const configureCustomDomain = () => {
  return postRequest(apiRoutes.KbCustomDomainConfigure, {}, getKbParams());
};

export const deleteCustomDomain = () => {
  return deleteRequest(apiRoutes.KbCustomDomainRemove, undefined, getKbParams());
};
